import { AppTheme } from "./types";

const weu: AppTheme = {
  name: "weu",
  colors: {
    primary: "#FFEEF0",
    background: "#FFF3F4",
    home: "#FFF3F4",
    text: "#EC89A5",
    icon: "#EC89A5",
    bgRecent: "linear-gradient(to right, #EC89A7, #FFEEF0)",
    backgroundGradient: "linear-gradient(to right, #EC89A7, #FFEEF0)",
    text2: "pink-400",
    text3: "white",
  },
  assets: {
    logo: "/images/Main_logo_beauty.svg",
    logoNavbar: "/images/logo_navbar_beauty.svg",
    iconBasePath: "/assets/icons/weubeauty/",
  },
  options: {
    grayscaleLogo: false,
    iconCategories: [
      { label: "코스메틱", image: "beauty5.svg", link: "/detailcategory/코스메틱" },
      { label: "네일 아트", image: "beauty4.svg", link: "/detailcategory/네일" },
      { label: "기타", image: "beauty1.svg", link : "/detailcategory/기타"},
      { label: "광고문의", image: "beauty6.svg",link:"/contact" },
      { label: "WE:U", image: "WEu_logo.svg", link: "https://weu.kr" },
    ],
    typeIcons: {
      blog: {
        active: "/assets/icons/weubeauty/iconUpdate/naver.svg",
        label: "블로그",
      },
      instagram: {
        active: "/assets/icons/weubeauty/iconUpdate/instagram.svg",
        label: "인스타그램",
      },
      tiktok: {
        active: "/assets/icons/weubeauty/iconUpdate/tiktok.svg",
        label: "틱톡",
      },
      youtube: {
        active: "/assets/icons/weubeauty/iconUpdate/youtube.svg",
        label: "유튜브",
      },
      all: {
        active: "/assets/icons/weubeauty/iconUpdate/weu.svg",
        label: "위유",
      },
    },
  },
};

export default weu;
